module.exports = {
	home: {
		bindAccountTitle: 'Connect Account',
		getNameTitle: 'Set Account Name',
		linkAccountTitle: 'Link Account',
		yinjicode: 'Account Key',
		changePsw: 'Set/Change Password',
		cancelAccountTitle: 'Delete Guest Account',
		loginDeviceTitle: 'Login Device Settings',
		bindAccountBtn: 'Connect Cat Fantasy Account',
		accountTitle: 'Account',
		checkAccountBtn: 'Switch Account',
		changePswTitle: 'Change Password',
		clickPswTitle: 'Tap to change',
		binded: 'Connected',
		goChangeBind: 'Change Connection',
		goBind: 'Go Connect',
		emailBindTitle: 'Connect Email',
		privacyTitls: 'Privacy Policy',
		FAQTitle: 'FAQ',
		kefu: 'Customer Service',
		logOffTitle: 'Delete Account',
		accountTitle1: 'Account Name',
		accountIdTitle: 'Account ID',
		changeEmailBtn: 'Change  Email',
		touristName: 'Guest User',
		touristTitle: 'Verified',
		logOut: 'Log Out',
		setNameTitle: 'Please enter your account name',
		bindAccountsTips:
			'Note: The connected account should not have any existing game characters.',
		gotoBindBtn: 'Go Connection',
		query: 'Self Search Center',
	},
	toast: {
		verifycodeBtn: 'Acquire',
		verifycodeBtn2: 'Acquire Again',
		comfirmBtn1: 'Confirm',
		comfirmBtn2: 'Cancel',
		emailPlaceholder: 'Enter your email',
		setNamePlaceholder: 'Enter your account name',
		setNameTitls:
			'Use characters between 7 and 16 long and must contain at least one letter.',
		verifyTitle: 'Enter verification code',
		pswTitle1: 'Enter a new password',
		pswTitle2: 'Confirm your new password',
		comfirmPswTips: 'Passwords entered need to be the same',
		verifypswTips:
			'Passwords must be between 6 and 18 characters long without Chinese characters and space.',
		newverifypswTips: 'Enter your password',
		verifyemailTips: 'Wrong format. Please enter again.',
		noEmail: 'Enter the email you want to connect',
		longTime: "Please verify again since you're inactive.",
		noInfo: 'No information received',
		binded: 'Your account has already been connected. Please contact Customer Service if you have any questions.',
		banCancelAccount:
			'Cannot disconnect account {name} used for verified login.',
		noEmail1: 'Enter your email',
		logout1: 'Device Logout Complete',
	},
	logoff: {
		logoffTipsText1:
			'1. We will process your request within 15 days from the day after you submit your account cancellation. If you log in this account during this 15-day period, the request will be canceled automatically.',
		logoffTipsText2:
			'2. This account will be no longer available after the deletion is complete.',
		logoffTipsText3:
			'3. If you have any questions, please contact Customer Service during work hours (Monday to Sunday 10:00 - 19:00).',
		logoffTipsBtn: 'Confirm',
		text1: 'To protect your account',
		text2: 'Your account deletion request has been submitted',
		text11: 'Your account deletion request has been submitted!',
		text3: `You have successfully submitted an account deletion request on {time}. Your account is currently in the process of being deleted.`,
		text4: `Your account will be deleted on {time}. If you log in this account, your account deletion process will be automatically canceled.`,
		text5: 'Notice',
		text9: 'Server',
		text7: 'Character',
		text8: 'Level',
		text10: 'Please read the deletion notice carefully',
		text6: 'When you confirm to delete your guest account, it will be reset to a new account, and your game history will not be recovered. Please note.',
		tourText2: 'Game',
		tourText3: 'Game Character',
		tourText4: 'Game UID',
		tourText5: 'Game Level',
		logoffScuessTips:
			'You have submitted for account deletion. Login expired.',
		agreementTips: "I've read and agree to {name}",
		buttonText: 'Read Deletion Notice',
		buttonText1: 'Go to Deletion',
		// clickAgreementTips:"请先阅读协议",
	},
	title: {
		title: 'Profile',
		title1: 'Privacy Policy',
		title2: 'FAQ',
		title3: 'Customer Service',
		title4: 'Security Verification',
		title5: 'Connect Account',
		title6: 'Connect Email',
		title7: 'Change Password',
		title8: 'Deletion Notice',
		title9: 'Account Deletion Request Notice',
		title10: 'Set Account Name',
		title11: 'Disconnect Account',
		title12: 'Link Account',
		title13: 'Deletion Notice',
		title14: 'Deletion Confirmation',
		title15: 'Account Deletion Request Notice',
		title16: 'Login Device Settings',
		title18: 'Change Connected Email',
		title19: 'Account Name Settings',
		title20: 'Deletion Notice',
		title21: 'Privacy Policy',
		title22: 'Terms of Service',
		netError:
			'The network is not valid for operation. Please check your network connection.',
	},
	verifyText: {
		titleTxt1:
			'To protect your account, please verify your email connected to this account before setting a new account name.',
		titleTxt2:
			'To protect your account, please verify your email connected to this account before linking a new account.',
		titleTxt3:
			'To protect your account, please verify your email connected to this account before changing the password.',
		titleTxt4:
			'To protect your account, please verify your email connected to this account before managing device.',
		titleTxt5:
			'To protect your account, please verify your email connected to this account before changing the connected email.',
		titleTxt6:
			'To protect your account, please verify your email connected to this account before disconnecting your email and account.',
		title1: 'E-mail',
	},
	successText: {
		goBack: 'Back',
		successTitle1: 'Connect complete',
		successTitle2: 'Disconnect complete',
		successTitle3: 'Change connection complete',
		successTitle4: 'Set complete',
	},
	bindAccountText: {
		text1: 'Disconnect',
		text2: 'Connect',
		text3: 'I have an account',
		text4: 'Register & Connect',
		text5: 'To protect your account, please verify your email before connection.',
		text6: 'Connect Cat Fantasy Account',
		text7: 'Enter your Account/Email/Account Name',
		text8: 'Your account has already been connected. Please contact Customer Service if you have any questions.',
	},
	preamble: {
		tx1: 'When you use a transfer code on a new device, the data on the old device will no longer be available.',
		tx2: 'Use Transfer Code',
		tx3: 'When transferring data to another device, please be aware that the data on this device will be deleted.',
		tx4: 'View Transfer Code',
		tx5: 'Enter Transfer Code',
		tx6: 'Password',
		tx7: "(Leave this field empty if you haven't set a transfer code password.)",
		tx8: 'Please enter your transfer code password.',
		tx9: 'The transfer code for the current device is not available.',
		tx10: 'No characters exist.',
		tx11: 'After tapping "Confirm," you will not be able to log in to the old device with this character.',
		tx12: 'Confirm',
		tx13: 'Successfully Used',
		tx14: 'Once a transfer code password is set, it cannot be changed.',
		tx15: 'Copy',
		tx16: 'Password Set',
		tx17: 'Copied',
		tx18: 'Copy failed, please copy manually',
	},
};
